import CommonCreate from "@/components/common/Create"
import VehicleForm from "../forms/VehicleForm"
import { useState } from "react"
import { vehicleForm } from "@/utils/objects"

const VehicleCreate = () => {
    const [formProp, setFormProp] = useState(vehicleForm)
    return (
        <CommonCreate title="Create new vehicle" resource="auto-service/vehicles" data={formProp}>
            <VehicleForm mode="create" formProp={formProp} setFormProp={setFormProp}/>
        </CommonCreate>
    )
}

export default VehicleCreate